<template>
  <div>
    <div class="dropdown position-relative">
      <div
        v-show="dropdownOpen"
        class="fixed-top w-100 h-100 "
        style="z-index: 10;"
        @click="dropdownOpen = false"
      />
    </div>
    <button
      type="button"
      class="btn btn-outline-none border rounded"
      @click="dropdownOpen = !dropdownOpen"
    >
      <GjIcon
        name="Filters"
        class="mr-1"
        size="20"
      />
      Filters {{ activeFilters }}
    </button>

    <!-- Dropdown Options -->
    <div
      v-show="dropdownOpen"
      class="
        position-absolute
        custom-position-first
        custom-width
        bg-white
        shadow-sm
        px-0
        mx-0
      "
      style="z-index: 50;"
    >
      <ul class="bg-white p-1 rounded border m-0">
        <li
          v-for="item in dropdownOptions"
          :key="item.id"
          class="
            d-flex
            align-items-center
            justify-content-between
            cursor-pointer
            bg-gray-100
            p-25
            dropdownOptions
          "
          @click="showNestedTabs(item)"
        >
          {{ item.name }}
          <GjIcon
            name="ArrowRight"
          />
        </li>
      </ul>

      <!-- Data Centers -->
      <div
        v-show="showDataCenters"
        class="fixed-top w-100 h-100"
        style="z-index: 10;"
        @click="showDataCenters = false"
      />

      <ul
        v-show="showDataCenters"
        class="
          list-style-none
          bg-white
          border
          rounded
          position-absolute
          custom-position
          custom-width
          shadow-sm
          m-0
          p-1
        "
        style="z-index: 50;"
      >
        <li
          v-for="item in healthcheckDataCenters"
          :key="item.id"
          class="d-flex aling-items-center gap-8 p-25 dropdownOptions cursor-pointer"
        >
          <b-form-radio
            v-model="localSelectedDataCenter"
            name="data-center"
            :value="item.id"
            :options="healthcheckDataCenters"
            @change="$emit('dataCenterFilterValue', localSelectedDataCenter)"
          >
            {{ item.name }} {{ item.slug ? `- ${item.slug}` : '' }}
          </b-form-radio>
        </li>
      </ul>

      <!-- State -->
      <div
        v-show="showState"
        class="fixed-top w-100 h-100"
        style="z-index: 10;"
        @click="showState = false"
      />

      <ul
        v-show="showState"
        class="
          list-style-none
          bg-white
          border
          rounded
          position-absolute
          custom-position
          shadow-sm
          custom-width
          m-0
          p-1
          mb-0
          pb-0
        "
        style="z-index: 50;"
      >
        <li
          v-for="item in stateOptions"
          :key="item.id"
          class="d-flex aling-items-center gap-8 p-25 dropdownOptions"
        >
          <b-form-radio
            v-model="localSelectedState"
            name="state"
            :value="item.id"
            @change="$emit('stateFilterValue', localSelectedState)"
          >
            {{ item.text }}
          </b-form-radio>
        </li>
      </ul>

      <!-- Comparison -->
      <div
        v-show="showComparison"
        class="fixed-top w-100 h-100"
        style="z-index: 10;"
        @click="showComparison = false"
      />

      <ul
        v-show="showComparison"
        class="
          list-style-none
          bg-white
          border
          rounded
          position-absolute
          custom-position
          shadow-sm
          custom-width
          m-0
          p-1
        "
        style="z-index: 50;"
      >
        <li
          v-for="item in comparisonOptions"
          :key="item.id"
          class="d-flex gap-8 p-25 dropdownOptions"
        >
          <b-form-radio
            v-model="localSelectedComparison"
            name="comparison"
            class="cursor-pointer"
            :value="item.id"
          >
            {{ item.text }}
          </b-form-radio>
        </li>
        <div class="position-relative">
          <validation-provider
            #default="{ errors }"
            name="Response Time"
            rules="required|numberInt"
          >
            <input-field
              label="Response Time"
              name="Response Time"
              label-position="top"
              class="mb-0 position-relative"
              :error="errors.length ? 'Response time required' : null"
              @keyup.stop.native.enter="filterResponseTimeOnEnter"
            >
              <b-input
                v-model="localResponseTime"
                placeholder="Response time (ms)"
                class="pr-3"
                type="number"
                :disabled="localSelectedComparison === null"
              />
              <span
                v-if="localResponseTime"
                class="position-absolute"
                style="right:10px; top:45px;"
              >(ms)</span>

            </input-field>
          </validation-provider>
        </div>
        <b-button
          variant="primary"
          class="w-100 btn btn-outline-dark"
          :disabled="localSelectedComparison === null || localResponseTime <= 0"
          @click="$emit('filterComparison', {option: localSelectedComparison, responseTime: localResponseTime })"
        >
          Filter
        </b-button>
        <hr>
        <div
          class="d-flex align-items-center dropdownOptions p-25"
          @click="clearComparisonFilter"
        >
          <GjIcon name="Close" />
          Clear
        </div>
      </ul>

      <!-- Status Codes -->

      <div
        v-show="showStatusCodes"
        class="fixed-top w-100 h-100"
        style="z-index: 10;"
        @click="showStatusCodes = false"
      />

      <ul
        v-show="showStatusCodes"
        class="
          list-style-none
          bg-white
          border
          rounded
          position-absolute
          custom-position
          shadow-sm
          custom-width
          m-0
          p-1
        "
        style="z-index: 50;"
      >

        <li>
          <validation-provider
            #default="{ errors }"
            name="Http Code"
            rules="required|validateHttp|max:3|min:3"
          >
            <input-field
              label="Http Code"
              name="Http Code"
              type="number"
              label-position="top"
              class="mb-0 position-relative"
              :error="errors.length ? errors[0] : null"
            >
              <b-form-input
                v-model="localHttpCode"
                placeholder="Http Code"
                type="number"
                class="pr-5"
                @keyup.stop.native.enter="filterStatusCodeOnEnter"
              />
              <span
                v-if="localHttpCode"
                class="position-absolute bg-white"
                style="right:10px; top:45px;"
              >(Http Code)</span>
            </input-field>
            <b-button
              :disabled="!localHttpCode || errors.length > 0"
              variant="primary"
              class="w-100 text-main btn btn-outline-dark"
              @click="$emit('statusCodeFilter', localHttpCode)"
            >
              Filter
            </b-button>
          </validation-provider>
        </li>
        <hr>
        <div
          class="d-flex align-items-center dropdownOptions p-25"
          @click="clearHttpCode"
        >
          <GjIcon name="Close" />
          Clear
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { required, validateHttp, numberInt } from '@validations'

export default {
  name: 'HealthcheckLogsFilters',
  components: { ValidationProvider },
  props: {
    healthcheckDataCenters: {
      type: Array,
      default: () => ([]),
    },
    stateOptions: {
      type: Array,
      default: () => ([]),
    },
    comparisonOptions: {
      type: Array,
      default: () => ([]),
    },
    selectedDataCenter: {
      type: Number,
      default: 0,
    },
    selectedState: {
      type: Number,
      default: 0,
    },
    selectedComparison: {
      type: Number,
      default: 0,
    },
    selectedResponseTime: {
      type: String,
      default: '',
    },
    selectedHttpCode: {
      type: [String, Number],
      default: null,
    },
    filterFinished: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      validateHttp,
      numberInt,
      dropdownOpen: false,
      showDataCenters: false,
      showState: false,
      showComparison: false,
      showStatusCodes: false,
      dropdownOptions: [
        {
          id: 1,
          name: 'All - Data Centers',
        },
        {
          id: 2,
          name: 'State',
        },
        {
          id: 3,
          name: 'Comparison',
        },
        {
          id: 4,
          name: 'Status Code',
        },
      ],
      localSelectedDataCenter: this.selectedDataCenter,
      localSelectedState: this.selectedState,
      localSelectedComparison: this.selectedComparison,
      localResponseTime: this.selectedResponseTime,
      localHttpCode: this.selectedHttpCode,
    }
  },
  computed: {
    activeFilters() {
      const filters = [
        this.selectedDataCenter !== 0,
        this.selectedState !== 2,
        this.selectedResponseTime !== null,
        this.selectedHttpCode !== null,
      ]

      const filtersCount = filters.filter(filter => filter).length

      return filtersCount === 0 ? '' : `( ${filtersCount} )`
    },
  },
  watch: {
    filterFinished(newVal) {
      if (newVal) {
        this.dropdownOpen = false
        this.showDataCenters = false
        this.showState = false
        this.showComparison = false
        this.showStatusCodes = false
        this.$emit('hideDropdowns', !newVal)
      }
    },
  },
  methods: {
    filterResponseTimeOnEnter() {
      if (this.localResponseTime <= 0) return

      this.$emit('filterComparison', { option: this.localSelectedComparison, responseTime: this.localResponseTime })
    },
    filterStatusCodeOnEnter() {
      const httpCodeRegex = /^(100|[1-9]\d{2})$/
      if (!httpCodeRegex.test(this.localHttpCode)) return

      this.$emit('statusCodeFilter', this.localHttpCode)
    },
    showNestedTabs(item) {
      const tabMap = {
        1: 'showDataCenters',
        2: 'showState',
        3: 'showComparison',
        4: 'showStatusCodes',
      }

      const property = tabMap[item.id]
      if (property) {
        this[property] = true
      }
    },
    clearComparisonFilter() {
      this.localSelectedComparison = null
      this.localResponseTime = null
      this.$emit('clearComparisonFilter', { option: this.localSelectedComparison, responseTime: this.localResponseTime })
      this.infoToast('Comparison filter cleared')
    },
    clearHttpCode() {
      this.localHttpCode = null
      this.$emit('clearHttpCode', this.localHttpCode)
      this.infoToast('Http Code filter cleared')
    },
  },
}

</script>

<style scoped>

.list-style-none {
  list-style: none;
}

.gap-8 {
  gap: 8px;
}

.custom-width{
  width: 220px;
}

.custom-position-first {
  right: 20px;
}

.dropdownOptions:hover{
  background-color: #f6f7f9;
  border-radius: 5px;
  cursor: pointer !important;
}

.p-25 {
  padding: 4px;
}

/* Data Centers */
.custom-position {
  left: -220px;
  top:0px
}
</style>
